module.exports = __webpack_public_path__ + "img/icon-percentage.3b20794d.png";